import { useEffect } from "react";

const FLAG = "vs-build-reloaded";

// After a publish, browsers can keep serving a cached index.html that points at the
// previous JS bundle. Compare the served bundle name with the loaded one and reload once.
export function useFreshBuild() {
  useEffect(() => {
    const loaded = [...document.querySelectorAll('script[src*="/static/js/"]')]
      .map((s) => s.src.split("/").pop())
      .find((name) => /^main\.[a-z0-9]+\.js$/.test(name));
    if (!loaded || sessionStorage.getItem(FLAG)) return;

    fetch(`/?_=${Date.now()}`, { cache: "no-store" })
      .then((r) => r.text())
      .then((html) => {
        const match = html.match(/\/static\/js\/(main\.[a-z0-9]+\.js)/);
        if (match && match[1] !== loaded) {
          sessionStorage.setItem(FLAG, "1");
          window.location.reload();
        }
      })
      .catch(() => {});
  }, []);
}
